export const en = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                Film Directed by <strong>Mohammad Gorjestani</strong> & <strong>Andrew Batista</strong>,
                Photography by <strong>Ike Edeani</strong>
            </p>`
    },
    {
      template: 'leadModule',
      body: `“Nostalgia is a natural side effect of immigration. Immigrants leave their home in search of a better life, and with that comes a lot of difficulty. There’s always going to be this tendency to look backwards and reminisce about how things were.”`
    },
    {
      template: 'textModule',
      leftImage: {
        width: 524,
        height: 698,
        url: 'assets/images/story/story-shervin/shervin-side-image1.jpg',
        alt: 'Shervin in his bedroom, surrounded by 1980s memorabilia'
      },
      text: `<p>
                No one should be defined by their interests, but sometimes a person’s passions can help you get to know them better. Shervin, from San Jose, is a writer, photo editor, and a Lyft driver. He’s also an ’80s enthusiast. But his interest in the decade—the American version of it—has a lot to do with the fact that he simply missed out on the whole thing.
            </p>
            <p>
                Shervin was born in 1992 (“I used to really hate that I wasn’t born in ’89, to say I technically was around for the ’80s,” he says), and his parents brought him to the United States in 1998. The whole family missed out on the American ’80s—and the ’80s in Iran were nothing like it.  
            </p>
            <p>
                For Iranians like Shervin’s parents, who had experienced a freer, more liberal Iran in the 1970s, the ’80s, were a restrictive, fearful time marked by the rise of the Islamic Revolution. Shervin notes: “When you bring up the ’80s to somebody from Iran, they are probably not going to have great memories. But when you bring up the ’80s with somebody in the US, they’ll go on and on about how great it was.”  
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 372,
          url: 'assets/images/story/story-shervin/shervin-image-gallery1-1.jpg',
          alt: 'Shervin looking at his model car collection',
          index: '01',
          caption: `<p>Shervin's love of cars aligns with his love for the '80s.</p>`
        },
        {
          width: 426,
          height: 338,
          url: 'assets/images/story/story-shervin/shervin-image-gallery1-2.jpg',
          alt: 'Shervin in his bedroom, featuring 1980s decor.',
          index: '02',
          caption: `<p>Shervin's bedroom is period-specific, featuring '80s memorabilia he has collected over the years.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `It was like, ‘What do you mean you haven’t seen Back to the Future? What do you mean you don’t know Depeche Mode?`,
      cite: 'Shervin'
    },
    {
      template: 'textModule',
      text: `<p>
                Young Shervin began attending school in California, where he quickly realized he was in the dark about all things American ’80s—MTV, Miami Vice, and Members Only jackets. And his parents didn’t know about any of these cultural artefacts, either.
            </p>
            <p>
                But the idea of looking back, of waxing nostalgic, already felt familiar. “Growing up, my parents were always reminiscing about the way things used to be. A time before things got difficult in Iran.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-shervin/shervin-image-gallery2-1.jpg',
          alt: 'Shervin seated, with his arms around his parents',
          index: '01',
          caption: `<p>Shervin enjoys a very close bond with his parents.</p>`
        },
        {
          width: 500,
          height: 335,
          url: 'assets/images/story/story-shervin/shervin-image-gallery2-2.jpg',
          alt: 'Shervin eating dinner with his family',
          index: '02',
          caption: `<p>As Shervin describes, "Nostalgia is the way I was raised. And in a way, my parents are still looking to the past."</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `My interests naturally gravitated towards this time that my parents hadn't experienced, this decade that they had been in the dark about. I was their window into what they missed.`,
      cite: 'Shervin'
    },
    {
      template: 'textModule',
      text: `<p>
                For Shervin and his parents, “Home didn't really feel like a place. It felt like a time. I think it’s probably true for a lot of immigrants. They leave their home country in search of a better life. They’re never really able to recapture that magic that they had in their home country.” Adjustment and assimilation can be difficult everyday realities. It follows, then, that many immigrants who face the difficulty of adapting to life in a new country might enjoy casting their minds to a more settled time. 
            </p>
            <p>
                As Shervin’s interests in ’80s-era America grew, so did his interest in sharing those interests with his parents. At some point, the connection between his love for that decade and his family history clicked for him. “When I was in high school, somebody asked me, ‘Why are you so interested in the ’80s?’ It wasn’t until something like twenty-five years later [after we came to America] when I started to really connect the dots.”
            </p>`
    },
    {
      template: 'fullImageModule',
      url: 'assets/images/story/story-shervin/shervin-full-image1.jpg',
      alt: 'Shervin in his car',
      width: 1600,
      height: 1200
    },
    {
      template: 'quoteModule',
      quote: `But nostalgia can be bad for you too. When you are so attached to an era from the past, you don't allow yourself to live in the present.`,
      cite: 'Shervin'
    },
    {
      template: 'textModule',
      text: `<p>
                Recently, though, Shervin has reckoned a bit with the intensity of his interest in the past. He’s dialing it back, even just a little—or at least living with an awareness he didn’t have before.          </p>
            <p>
                “A lot of people associate me with things from the ’80s, the classic cars. And for a long time, I had no problem with that. I sort of believed it too. I said, ‘Well yeah that's that's kind of who I am.’ That shapes everything about me. But nostalgia can be bad for you too. When you are so attached to an era from the past, you don’t allow yourself to live in the present, and I had no idea was really doing that to myself.”        </p>
            <p>
                Regardless of his own experience, Shervin believes there’s a lesson from this country’s past that should be heeded: “If you really start looking back, everyone is an immigrant in America. The only difference is we’re just new here. And I’m proud to be an immigrant. I’m proud to be Iranian-American.”
            </p>`
    },
    {
      template: 'donateModule',
      title: 'Make a donation',
      subtitle: 'And join our efforts',
      body: `<p> 
                Every issue contributing to our current immigration crisis is interconnected. Your stories inspire us to continue to take a stand — when our community of riders and drivers is threatened, we’re encouraged to take action.  
                <br><br>
                In honor of Shervin and his family, we are humbled to support <a href="http://www.parsequalitycenter.org/" target="_blank">Pars Equality Center</a> — a social and legal services organization dedicated to helping the Iranian-American and other Persian-speaking communities realize their full potential as informed, self-reliant, and responsible members of the American society. 
                <br><br>
                Please join us in supporting them. 
             </p>`,
      cta: 'Make a donation',
      url: 'http://www.parsequalitycenter.org/donate-1'
    },
    {
      template: 'nextStoryModule',
      id: 'story-zahraa',
      title: 'My Three Sons',
      alt: 'Zahraa looking over the water',
      location: 'Los Angeles, CA',
      description: 'Muslim in America',
      imageSize1URL: 'assets/images/carousel/carousel-image-zahraa-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-zahraa-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344700461.sd.mp4?s=71fcc00b0b2807fcb5abd8651eb156f35f4de487&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700838.sd.mp4?s=0890b719310b39fa3734adab1570b0f85ff3df9d&profile_id=165'
    }
  ]
};

export const es = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                Video dirigido por <strong>Mohammad Gorjestani</strong> y <strong>Andrew Batista</strong>,
                Fotografía de <strong>Ike Edeani</strong>
            </p>`
    },
    {
      template: 'leadModule',
      body: `“La nostalgia es un efecto secundario natural de la inmigración. Los inmigrantes abandonan su hogar en busca de una vida mejor, y eso provoca muchas dificultades. Siempre habrá una tendencia a mirar hacia atrás y recordar cómo eran las cosas".`
    },
    {
      template: 'textModule',
      leftImage: {
        width: 524,
        height: 698,
        url: 'assets/images/story/story-shervin/shervin-side-image1.jpg',
        alt: 'Shervin en su habitación, rodeado de recuerdos de los años 80'
      },
      text: `<p>
                Nadie debe definirse por sus intereses, pero a veces las pasiones de una persona pueden ayudar a conocerla mejor. Shervin, de San José, es escritor, editor de fotos y conductor de Lyft. También es un amante de los años ochenta. Pero su interés en la década —la versión estadounidense de la misma—, tiene mucho que ver con el hecho de que simplemente se perdió de todo lo que pasó.
            </p>
            <p>
                Shervin nació en 1992 ("Solía odiar el no haber nacido en el 89, para decir que técnicamente estuve en los años ochenta", dice), y sus padres lo trajeron a los Estados Unidos en 1998. Toda la familia se perdió los años ochenta de los Estados Unidos, y los ochenta en Irán no tuvieron nada que ver.  
            </p>
            <p>
                Para los iraníes, como los padres de Shervin, que habían experimentado un Irán más libre y liberal en la década de 1970, los ochenta fueron una época restrictiva y atemorizante, marcada por el surgimiento de la Revolución Islámica. Shervin señala: "Cuando le mencionas los años ochenta a alguien de Irán, probablemente no evoque buenos recuerdos. Pero, cuando le mencionas los ochenta a alguien en los EE. UU., te dirán lo maravillosos que fueron".  
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 372,
          url: 'assets/images/story/story-shervin/shervin-image-gallery1-1.jpg',
          alt: 'Shervin mirando su colección de autos a escala',
          index: '01',
          caption: `<p>El amor de Shervin por los autos es proporcional a su amor por los años ochenta.</p>`
        },
        {
          width: 426,
          height: 338,
          url: 'assets/images/story/story-shervin/shervin-image-gallery1-2.jpg',
          alt: 'Shervin en su habitación decorada de los años ochenta.',
          index: '02',
          caption: `<p>La habitación de Shervin es fiel a una época y está decorada con recuerdos de los ochenta que ha coleccionado a lo largo de los años.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Era como, '¿Cómo que no has visto Volver al futuro? ¿Qué quieres decir con que no conoces a Depeche Mode?`,
      cite: 'Shervin'
    },
    {
      template: 'textModule',
      text: `<p>
                El joven Shervin empezó a ir a la escuela en California, donde se dio cuenta rápidamente de que no sabía nada de los años ochenta: MTV, Miami Vice y las chaquetas Member's Only. Y sus padres tampoco sabían nada de estos artefactos culturales.
            </p>
            <p>
                Pero la idea de mirar hacia atrás, de encerar nostálgico, ya me resultaba familiar. “Al crecer, mis padres siempre recordaban cómo solían ser las cosas. Un tiempo antes de que las cosas se pusieran difíciles en Irán ".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-shervin/shervin-image-gallery2-1.jpg',
          alt: 'Shervin sentado abrazando a sus padres',
          index: '01',
          caption: `<p>Shervin disfruta de un vínculo muy cercano con sus padres.</p>`
        },
        {
          width: 500,
          height: 335,
          url: 'assets/images/story/story-shervin/shervin-image-gallery2-2.jpg',
          alt: 'Shervin cenando con su familia',
          index: '02',
          caption: `<p>Como lo describe Shervin, "la nostalgia es la forma en que me criaron. Y, en cierto modo, mis padres aún miran hacia el pasado".</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `De una forma natural, me empecé a interesar en ese momento que mis padres nunca experimentaron, esta década que para ellos fue oscuridad. Yo fui la ventana que les mostró lo que se perdieron.`,
      cite: 'Shervin'
    },
    {
      template: 'textModule',
      text: `<p>
                "Para Shervin y sus padres," el hogar no se sentía como un lugar. Se sentía como un momento. "Creo que es una realidad para muchos inmigrantes. Salen de su país de origen en busca de una vida mejor. Nunca logran recuperar esa magia que tenían en sus países". El ajuste y la asimilación pueden ser una difícil realidad de todos los días. De ahí se deduce, entonces, que muchos inmigrantes que enfrentan la dificultad de adaptarse a la vida en un nuevo país, pueden disfrutar el recordar tiempos de mayor estabilidad. 
            </p>
            <p>
                A medida que se desarrollaron los intereses de Shervin en la era de los ochenta en Estados Unidos, también lo hizo su interés en compartir esos intereses con sus padres. En algún momento, la conexión entre su amor por esa década y su historia familiar hizo un clic para él. "Cuando estaba en la escuela, alguien me preguntó: '¿Por qué estás tan interesado en los años ochenta?' No fue hasta unos veinticinco años más tarde [después de que llegamos a Estados Unidos] cuando empecé a hacer todas las conexiones".
            </p>`
    },
    {
      template: 'fullImageModule',
      url: 'assets/images/story/story-shervin/shervin-full-image1.jpg',
      alt: 'Shervin en su auto',
      width: 1600,
      height: 1200
    },
    {
      template: 'quoteModule',
      quote: `Pero la nostalgia también puede ser mala para ti. Cuando estás tan apegado a una era del pasado, no te permites vivir el presente.`,
      cite: 'Shervin'
    },
    {
      template: 'textModule',
      text: `<p>
                Sin embargo, recientemente, Shervin ha reconsiderado la intensidad de su interés por el pasado. Lo está atenuando, aunque solo un poco, o al menos viviendo con una conciencia que antes no tenía.          </p>
            <p>
                "Mucha gente me asocia con cosas de los ochenta, los autos clásicos. Y durante mucho tiempo, no tuve ningún problema con eso. Yo también lo creí. Dije: 'Bueno, sí, eso es lo que soy'. Eso le ha dado forma a lo que soy. Pero la nostalgia también puede ser mala para ti. Cuando estás tan apegado a una era del pasado, no te permites vivir el presente, y no tenía idea de que realmente me lo estaba haciendo a mí mismo ".        </p>
            <p>
                Independientemente de su propia experiencia, Shervin cree que hay una lección del pasado de este país que debe tenerse en cuenta: “Si realmente empiezas a mirar hacia atrás, todos somos inmigrantes en Estados Unidos. La única diferencia es que somos nuevos aquí. Y estoy orgulloso de ser un inmigrante. Estoy orgulloso de ser iraní-estadounidense". 
            </p>`
    },
    {
      template: 'donateModule',
      title: 'Haz una donación',
      subtitle: 'Unete a nuestra causa',
      body: `<p> 
                Todos los problemas que contribuyen a nuestra actual crisis de inmigración están interconectados. Tus historias nos inspiran a seguir tomando una postura: cuando nuestra comunidad de viajeros y conductores sea amenazada, nosotros tomaremos las medidas pertinentes.  
                <br><br>
                En honor a Shervin y su familia, nos sentimos honrados de apoyar a <a href="http://www.parsequalitycenter.org/" target="_blank">Pars Equality Center</a>, una organización de servicios sociales y legales dedicada a ayudar a las comunidades iraní-estadounidenses y a otras personas de habla persa a alcanzar su máximo potencial como miembros informados, independientes y responsables de la sociedad estadounidense. 
                <br><br>
                Por favor, únete a nosotros para apoyarlos. 
             </p>`,
      cta: 'Haz una donación',
      url: 'http://www.parsequalitycenter.org/donate-1'
    },
    {
      template: 'nextStoryModule',
      id: 'story-zahraa',
      title: 'Mis tres hijos',
      alt: 'Zahraa mirando por encima del agua',
      location: 'Los Angeles, CA',
      description: 'Una musulmana en Estados Unidos',
      imageSize1URL: 'assets/images/carousel/carousel-image-zahraa-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-zahraa-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344700461.sd.mp4?s=71fcc00b0b2807fcb5abd8651eb156f35f4de487&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700838.sd.mp4?s=0890b719310b39fa3734adab1570b0f85ff3df9d&profile_id=165'
    }
  ]
};

export default {en, es};

